import React from 'react'
import { CSSTransition } from 'react-transition-group'
import emailjs from "emailjs-com";

const Contactme = ({nama}) => {
    
    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('gmail', 'dzikri_github_template', e.target, 'user_J42afc1zhqExNI6n4yHMQ')
        .then((result) => {
            console.log(result.text);
            alert("Message has been sent. Thankyou :)")
        }, (error) => {
            console.log(error.text);
        });

        e.target.reset();
    }
    

    return (
        <CSSTransition in={true} appear={true} timeout={600} classNames="fade">
            <div>
            <div className='container'>
                <div className='email'>
                    <form onSubmit={sendEmail}>    
                        <p className='head'> Send Me A Message </p>
                        <div className='inputbox'>
                        
                        <span className='labelname'>Name:</span>
                        <input type="text" className="name" name="name" defaultValue={nama} required='required'/>
                    
                    
                        <span className='labelemail' >Email:</span>
                        <input type="text" className="emailing" name="email" required='required'/>
                
                    
                        <span className='labelmessage'>Message:</span>
                        <textarea className="message" required='required' name="message"></textarea>

                        <input type="submit" className='submit-email' value='Send'></input>
                        </div>
                    </form>
                </div>
                
                <div className='bio'>
                    <div className='ig'>
                        <h3> Linkedin </h3>
                        <div className='box'>
                            <a href="https://www.linkedin.com/in/dzikriqalam/"><img src="/logo/LI-In-Bug.png" alt='linkedin' width='30px' height='30px' className="logo" /></a>
                            <a href="https://www.linkedin.com/in/dzikriqalam/" className='link'> Dzikri Qalam Hatorangan </a>
                        </div>
                        <h3> Whatsapp </h3>
                        <div className='box'>
                            <a href="https://wa.me/6287855474426"><img src='/logo/WA-Logo.png' alt='Whatsapp' width='30px' height='30px' className="logo" /></a>
                            <a href="https://wa.me/6287855474426" className='link'> +6287855474426 </a>
                        </div>
                        <h3> Line </h3>
                        <div className='box'>
                            <a href="http://line.me/ti/p/~dzikriqalamm"><img src="/logo/Line-Logo.png" alt="Line" width='30px' height='30px' className="logo" /></a>
                            <a href="http://line.me/ti/p/~dzikriqalamm" className='link'> @dzikriqalamm </a>
                        </div>
                        <h3> Instagram </h3>
                        <div className='box'>
                            <a href="https://www.instagram.com/dzikriqalam/"><img src="https://www.transparentpng.com/thumb/logo-instagram/YfpFOL-logo-instagram-free-transparent.png" alt="logo Instagram free transparent @transparentpng.com" width='30px' height='30px' className="logo"/></a>
                            <a href="https://www.instagram.com/dzikriqalam/" className='link'> @dzikriqalam </a>
                        </div>
                    </div>
                </div>
            </div> 
            </div>
        </CSSTransition>
    )
}

export default Contactme
